module.exports = (original)-> ({React,FormGroup,Pikaday})->
  (props)=> 
    return <div></div> if(!props.org) 
    #make it possible to return global override of component
    {id, name, address, postcode, country, email, phone, website, membership_start,membership_renew,membership_type,membership_id,credits,notify_credits,reference,elibrary,domains,membership_fee,membership_fee_currency,membership_term,membership_inv_num} = props.org
    extrafields = [
      <FormGroup label="Membership ID" key="membership_id">
        <input type="text" className="form-control" id="membership_id" placeholder="" value={membership_id ?= ""} onChange={(e)=> props.onUpdate(id,"membership_id",e.target.value)} />
      </FormGroup>
      <FormGroup label="Membership Start" key="membership_start">
        <Pikaday key="membership_start" className="form-control" value={if membership_start then new Date(membership_start) else ""} onChange={(dt)=> props.onUpdate(id,'membership_start',dt) } />
     </FormGroup>
      <FormGroup label="Membership Exp." key="membership_renew">
        <Pikaday key="membership_renew" className="form-control" value={if membership_renew then new Date(membership_renew) else ""} onChange={(dt)=> props.onUpdate(id,'membership_renew',dt) } />
      </FormGroup>
      <FormGroup label="Membership Type" key="membership_type">
        <input type="text" className="form-control" id="membership_type" placeholder="" value={membership_type ?= ""} onChange={(e)=> props.onUpdate(id,"membership_type",e.target.value)} />
      </FormGroup>

      <FormGroup label="Membership Term" key="membership_term">
        <input type="number" className="form-control" id="membership_term" placeholder="" value={membership_term ?= ""} onChange={(e)=> props.onUpdate(id,"membership_term",e.target.value)} />
      </FormGroup>

      <FormGroup label="Membership Inv No." key="membership_inv_num">
        <input type="text" className="form-control" id="membership_inv_num" placeholder="" value={membership_inv_num ?= ""} onChange={(e)=> props.onUpdate(id,"membership_inv_num",e.target.value)} />
      </FormGroup>

      <FormGroup label="Membership Fee" key="membership_fee">
        <div style={{display:"flex",gap:5}}>
          <select className="form-control" id="membership_fee_currency" onChange={(e)=> props.onUpdate(id,"membership_fee_currency",e.target.value)} style={{flex:1}}>
            <option value="GBP">£ (GBP)</option>
            <option value="USD">$ (USD)</option>
            <option value="EUR">€ (EUR)</option>
          </select>
          <input type="text" style={{flex:3}} className="form-control" id="membership_fee" placeholder="" value={membership_fee ?= ""} onChange={(e)=> props.onUpdate(id,"membership_fee",e.target.value)} />
        </div>
      </FormGroup>

      <FormGroup label="Remaining Credits" key="credits">
        <input type="text" className="form-control" id="membership_type" placeholder="" value={credits ?= ""} onChange={(e)=> props.onUpdate(id,"credits",e.target.value)} />
      </FormGroup>
      <FormGroup label="Domains" key="domains">
         <input type="text" className="form-control" id="domains" value={domains || "" } onChange={(e)=> props.onUpdate(id,"domains",e.target.value)} />
      </FormGroup>
      <FormGroup label="Salesforce Id" key="reference">
        <input type="text" className="form-control" id="reference" value={reference || "" } readOnly onChange={(e)=> props.onUpdate(id,"reference",e.target.value)} />
      </FormGroup>
      <FormGroup label="Notify Primary Contacts of Credit Use" key="notify_credits" checkbox={true}>
        <input type="checkbox" id="notify_credits" checked={notify_credits || false} onChange={(e)=> props.onUpdate(id,"notify_credits",e.target.checked)} />
      </FormGroup>
      <FormGroup label="Elibrary" key="elibrary" checkbox={true}>
        <input type="checkbox" id="elibrary" checked={elibrary || false} onChange={(e)=> props.onUpdate(id,"elibrary",e.target.checked)} />
      </FormGroup>
    ]
    # below splices the new fields into the original form
    original(props).concat(extrafields)
    #originalfields = original(props)
    #offset = originalfields.length-2
    #originalfields[...offset].concat extrafields,originalfields[offset...]